import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { SaferpayFieldTypeEnum, SaferpayFieldValidationReason, } from '@as-react/common-types';
import { TextAlpha, SaferpayField as AndesSaferpayField } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const SaferpayField = ({ id, label, paymentMethods, type, validation, withGlossary, icon, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const getErrorInfoField = () => {
        switch (type) {
            case SaferpayFieldTypeEnum.CARDNUMBER:
                if ((validation === null || validation === void 0 ? void 0 : validation.reason) === SaferpayFieldValidationReason.UNSUPPORTED) {
                    return paymentMethods.length > 1
                        ? `${paymentMethods.slice(0, -1).join(', ')} ${t(`${I18N_NAMESPACES.buy}:buy.or`)} ${paymentMethods.slice(-1)}`
                        : paymentMethods[0];
                }
                return '';
            default:
                return '';
        }
    };
    const error = (validation === null || validation === void 0 ? void 0 : validation.isValid) !== undefined && !(validation === null || validation === void 0 ? void 0 : validation.isValid) ? (_jsxs(TextAlpha, { color: "error", variant: "bodyS", children: [t(`${I18N_NAMESPACES.buy}:buy.payment.saferpay.field.${validation.fieldType}.error.${validation.reason || SaferpayFieldValidationReason.INVALID}`), getErrorInfoField()] })) : undefined;
    const tooltip = withGlossary ? t(`${I18N_NAMESPACES.buy}:buy.payment.saferpay.field.${type}.description`) : undefined;
    return (_jsx(AndesSaferpayField, { id: id, label: label, icon: icon, error: error, tooltipText: tooltip, testId: `saferpay-field-${type}` }));
};
